import CommonUiModel from "../common/commonUiModel";

const parameterSetConfig = {
	title: "ParameterSets",
	api: "ParameterSets",
	customAddText: "Add Parameter Sets",
	idProperty: 'ParameterSetId',
	overrideFileName: "Parameter Set",
	formTitle: 'Parameter Set',
	navigateBack: -1,
	hideBreadcrumbInGrid: true,
	showHistory: false,
	module: 'ScopeMaster',
	parseResponseActions: ['lookups'],
	createRequestPayload: (reqData, context) => {
		if(context.action === 'lookups') {
			reqData.url = `${context.api}/combo`;
			reqData.disableLoader = true;
			reqData.additionalParams = { method: 'POST' };
		}
	},
	parseResponsePayload: ({ responseData, action }) => {
		if(action === 'lookups') {
			return responseData.lookups["ScopeRegion"] || [];
		}
	},
	columns: [
		{ field: 'ScopesPerBasin', label: 'Scopes Per Basin', type: 'number', width: 150, min: 1, required: true, max: '{MaxScopesPerBasin}', pinned: "left" },
		{ field: 'RegionId', label: 'Region', type: 'select', width: 150, lookup: 'ScopeRegion', dependsOn: ["EquipmentScopeId"], required: true },
		{ field: 'ChemistryId', label: 'Chemistry', type: 'select', width: 150, lookup: 'chemistry', selectField: 'ChemistryId', required: true },
		{ field: 'DetergentId', label: 'Detergent', type: 'select', width: 150, lookup: 'detergent', selectField: 'DetergentId', required: true },
		{ label: 'Use Alcohol', field: 'Alcohol', width: 150, type: 'boolean' },
		{ label: 'Double Wash', field: 'DoubleWash', type: 'boolean', width: 150 }
	]
};

const ParameterSet = new CommonUiModel(parameterSetConfig);
export default ParameterSet;
export { parameterSetConfig };